import React from 'react';
import classNames from 'classnames';
import Section from '@components/Section';
import Storage from '@support/Storage';
import { CircledIIcon, XIcon } from '@components/Icons';
import styles from './ContactFormTip.module.scss';

const key = 'dismissed-form-information';

export default function Tip() {
  const [showTip, setShowTip] = React.useState(
    Storage.get('dismissed-form-information') !== 'true',
  );
  // FIXME why do we have this if it is never being changed?
  const [dismissed] = React.useState(false);

  function handleDismiss(e) {
    e.preventDefault();
    Storage.set(key, 'true');
    setShowTip(false);
  }

  if (!showTip) {
    return null;
  }

  return (
    <div className={classNames(styles.tip, dismissed ? styles.dismissed : null)}>
      <Section.Title IconComponent={CircledIIcon} className={styles.title}>
        Profile Editing Tip
      </Section.Title>
      Your Notes and Sources always remain private to you. When editing a profile please make sure
      to provide correct information so we can accurately represent this person.{' '}
      <a className="link-plain" target="_blank" href="https://go.clay.earth/edit-cards">
        Learn more →
      </a>
      <button className={`btn-none ${styles.dismiss}`} type="button" onClick={handleDismiss}>
        <XIcon width={10} height={10} hover />
      </button>
    </div>
  );
}
